































































































































































































import { Component, Prop, Model } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import { BusEvent } from '@/models/bus';

import TranscriptArpabet from '../api/transcriptArpabet';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';

@Component({
  components: {
    modal: Modal,
    'edit-icon': EditIcon
  }
})
export default class FieldTranscriptArpabet extends CommonVue {
  @Model('update') public transcript_arpabet_list!: TranscriptArpabet[];
  @Prop({ type: String }) public sentence!: string;
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;

  public AUTO_TRANSCRIPTION_INDICATOR =
    TranscriptArpabet.AUTO_TRANSCRIPTION_INDICATOR;
  public TRANSCRIPTION_FLAGS = TranscriptArpabet.FLAGS;
  public canLink = false;
  public mustLink = false;
  public mustDrop = false;
  public useAutomaticTranscription = false;
  public word: TranscriptArpabet = null;
  public isNewWord: boolean = false;
  public showModal: boolean = false;

  public edit(word: TranscriptArpabet) {
    this.word = word;
    this.useAutomaticTranscription =
      this.word.trans.indexOf(this.AUTO_TRANSCRIPTION_INDICATOR) > -1;
    this.canLink = this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[0]) > -1;
    this.mustLink = this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[1]) > -1;
    this.mustDrop = this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[2]) > -1;
    this.isNewWord = false;
    this.showModal = true;
  }

  public newWord() {
    this.word = new TranscriptArpabet();
    this.isNewWord = true;
    this.showModal = true;
  }

  // noinspection JSMethodCanBeStatic
  public newTranscription(word: TranscriptArpabet) {
    word.trans.push('');
  }

  public saveClicked() {
    if (!this.word) {
      return;
    }

    this.busy = true;

    try {
      this.checkMandatoryFields();
      if (this.isNewWord) {
        this.transcript_arpabet_list.push(this.word);
      }
      this.processTrans();
      this.$emit(
        'updateSentence',
        this.newSentence(this.transcript_arpabet_list)
      );

      this.busy = false;
      this.showModal = false;
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not save word', e);
    }
  }

  public processTrans() {
    // For each custom transcription
    this.word.trans.forEach((word, i) => {
      // Remove the symbols that are not on the list
      //this.word.trans[i] = this.word.trans[i].split(' ').filter((el) => {
      //  return TranscriptArpabet.getSymbols().indexOf(el.toUpperCase()) > -1;
      //}).join(' ').toUpperCase();

      // Do not remove any symbols but still uppercase:
      this.word.trans[i] = this.word.trans[i].toUpperCase();
    });

    // Remove empty entries
    this.word.trans = this.word.trans.filter((value) => {
      return value.length !== 0;
    });

    // Add symbol to represent the automatic transcription
    if (this.useAutomaticTranscription) {
      this.word.trans.push(this.AUTO_TRANSCRIPTION_INDICATOR);

      // Remove symbol to represent the automatic transcription
    } else if (
      this.word.trans.indexOf(this.AUTO_TRANSCRIPTION_INDICATOR) > -1
    ) {
      this.word.trans = this.word.trans.filter((value) => {
        return value === this.AUTO_TRANSCRIPTION_INDICATOR;
      });
    }

    if (this.canLink) {
      this.word.flags.push(this.TRANSCRIPTION_FLAGS[0]);
    } else if (this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[0]) > -1) {
      this.word.flags = this.word.flags.filter((value) => {
        return value === this.TRANSCRIPTION_FLAGS[0];
      });
    }
    if (this.mustLink) {
      this.word.flags.push(this.TRANSCRIPTION_FLAGS[1]);
    } else if (this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[1]) > -1) {
      this.word.flags = this.word.flags.filter((value) => {
        return value === this.TRANSCRIPTION_FLAGS[1];
      });
    }
    if (this.mustDrop) {
      this.word.flags.push(this.TRANSCRIPTION_FLAGS[2]);
    } else if (this.word.flags.indexOf(this.TRANSCRIPTION_FLAGS[2]) > -1) {
      this.word.flags = this.word.flags.filter((value) => {
        return value === this.TRANSCRIPTION_FLAGS[2];
      });
    }

    // Remove duplicates
    this.word.flags = this.word.flags.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    this.word.trans = this.word.trans.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  }

  // noinspection JSMethodCanBeStatic
  public newSentence(transcript_arpabet_list) {
    const joined = [];
    for (const word of transcript_arpabet_list) {
      joined.push(word.text);
    }
    return joined.join(' ');
  }

  public checkMandatoryFields() {
    // Check if text is filled
    if (!this.word.text || this.word.text === '') {
      throw Error('Please insert the text for your sentence.');
    }

    // Check if transcriptions are valid
    for (let el of this.word.trans) {
      if (
        !el
          .split(' ')
          .every((a) =>
            TranscriptArpabet.getSymbols().includes(a.toUpperCase())
          )
      ) {
        throw Error(`There are invalid phonemes ${el}, re-check them.`);
      }
    }
  }

  public deleteClicked() {
    const newList = this.transcript_arpabet_list.filter((value) => {
      return value !== this.word;
    });

    this.$emit('update', newList);
    const a = this.newSentence(newList);
    this.$emit('updateSentence', a);
    this.showModal = false;
  }
}
